import { useTranslation } from "react-i18next";
import { Button, notification } from "antd";
import { observer } from "mobx-react-lite";

import { api } from "../../api";
import telegramIconUrl from "../../assets/img/telegram-icon.svg";
import { userStore } from "../../stores/userStore";
import { usePendingAction } from "../../utils/usePendingAction";

export const TelegramSocialAccount = observer(function TelegramSocialAccount() {
  const { t } = useTranslation();
  const { pending: linkLoading, run: runLink } = usePendingAction();
  const telegramName =
    userStore.profile?.integrations?.telegram_name ?? null;

  async function handleLink() {
    await runLink(async () => {
      try {
        const { redirect_url } = await api.integration.getTelegramShortened();
        const link = document.createElement("a");
        link.href = redirect_url;
        link.target = "_blank";
        link.click();
      } catch {
        notification.error({ message: t("errors.shared.common_error") });
      }
    });
  }

  const icon = (
    <span className="social-accounts__icon">
      <img src={telegramIconUrl} width={24} height={24} alt="Telegram" />
    </span>
  );

  if (telegramName !== null) {
    return (
      <div className="social-accounts__row">
        <div className="social-accounts__chip">
          {icon}
          <span className="social-accounts__chip-value">{telegramName}</span>
        </div>
      </div>
    );
  }

  return (
    <div className="social-accounts__row">
      {icon}
      <Button size="large" loading={linkLoading} onClick={handleLink}>
        {t("profile.socialAccounts.link")}
      </Button>
    </div>
  );
});
